import type { ImageType } from '@vizit/api';
import { Tooltip, TooltipTrigger } from '@vizit/atoms';
import { LockIcon } from '@vizit/icons';
import { Button as AriaButton } from 'react-aria-components';

const IMAGE_TYPE_LABELS: Record<ImageType, string> = { hero: 'Hero', carousel: 'Carousel' };

export interface ImageTypeChipProps {
  /**
   * The locked image type
   */
  scope: ImageType;
}

/**
 * The image type of a benchmark or a collection, locked at creation: a disabled-looking field with a lock and the
 * type's name, with a tooltip
 * saying why it cannot change. Focusable so keyboard users reach the tooltip.
 */
export function ImageTypeChip({ scope }: ImageTypeChipProps) {
  return (
    <TooltipTrigger delay={200}>
      <AriaButton
        aria-label={`Image type: ${IMAGE_TYPE_LABELS[scope]}, set at creation`}
        className="flex h-18 min-w-[114px] cursor-default items-center gap-4 border border-primary bg-gray-true-50 px-6 font-regular text-md text-quaternary outline-none data-[focus-visible]:ring-1 data-[focus-visible]:ring-gray-utility-700"
      >
        <span className="flex h-10 w-10 shrink-0 items-center justify-center text-gray-utility-400">
          <LockIcon size={18} aria-hidden />
        </span>
        <span>{IMAGE_TYPE_LABELS[scope]}</span>
      </AriaButton>
      <Tooltip>Set at creation</Tooltip>
    </TooltipTrigger>
  );
}
